import React from 'react';
import { shapes } from '@cimpress/react-components';
import { FlexBox, JustifyContent } from '../../utils/css-classes';

const { Spinner } = shapes;
// tslint:disable-next-line:variable-name
const Loading = () => (
  <div className={`${FlexBox.FLEX} ${JustifyContent.CENTER}`}>
    <Spinner />
  </div>
);

export default Loading;
